// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P3kg6","content":"styles_content__1k5Zo"};